// extracted by mini-css-extract-plugin
export default {"fallback":"ErrorBoundary_fallback__q7ylv","message":"ErrorBoundary_message__2Uc5-","retry":"ErrorBoundary_retry__VjsGO"};